module.exports = __webpack_public_path__ + "static/media/order-virtual-card-sample.fab21bb6.csv";